// extracted by mini-css-extract-plugin
export var baseButton = "_og-0";
export var controlsArrowKeys = "_og-1";
export var controlsResetButton = "_og-2";
export var lightGameButton = "_og-4 _og-0";
export var playAgainButton = "_og-5 _og-0";
export var startGameButton = "_og-3 _og-0";